export const shouldAutoFetchInfiniteProducts = (
  disableAutoFetch?: boolean
): boolean => disableAutoFetch !== true

export const shouldLoadNextInfiniteProductsPage = ({
  disableAutoFetch,
  isSentinelVisible,
  hasMore,
  loading,
  loadingMore,
}: {
  disableAutoFetch?: boolean
  isSentinelVisible: boolean
  hasMore: boolean
  loading: boolean
  loadingMore: boolean
}): boolean =>
  shouldAutoFetchInfiniteProducts(disableAutoFetch) &&
  isSentinelVisible &&
  hasMore &&
  !loading &&
  !loadingMore

